import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  insuranceData: {},
  isLoading: false,
  error: "",
  hasData: false,
  insuranceDataStatus: {
    status: false,
    message: ""
  }
};
const travelInsuranceSlice = createSlice({
  name: "travelInsurance",
  initialState,
  reducers: {
    travelInsuranceRequest: state => {
      state.isLoading = true;
    },
    travelInsuranceSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.insuranceData = action.payload;
      state.insuranceDataStatus.status = true;
    },
    travelInsuranceFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.insuranceDataStatus.status = false;
    }
  }
});
export const {
  travelInsuranceRequest,
  travelInsuranceSuccess,
  travelInsuranceFailure
} = travelInsuranceSlice.actions;
export default travelInsuranceSlice.reducer;